<template>
    <div id="newEntity_main">

    </div>
</template>

<script>
  export default {
    name: 'newEntitiy'
  }
</script>

<style scoped>
    #newEntity_main{
        display: flex;
        height: 100%;
        width: 350px;
        flex-direction: column;
    }
</style>
